import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../../context/LanguageContext";
import styles from "./LanguageSelector.module.scss"; // crée un module si besoin

const LanguageSelector = () => {

    const navigate = useNavigate();

    const { language, changeLanguage } = useContext(LanguageContext);
    const [showModal, setShowModal] = useState(false);
    const [pendingLang, setPendingLang] = useState(null);

    const handleLanguageChange = (lang) => {

        const supportedLangs = ['fr', 'en', 'de', 'es', 'it'];
        const regex = new RegExp(`^(questions_villages|questions_inde)_(${supportedLangs.join('|')})_\\d+$`);
        const hasMatchingKey = Object.keys(localStorage).some((key) => regex.test(key));

        // if (hasMatchingKey) {
        //     setPendingLang(lang);
        //     setShowModal(true);
        // } else {
            changeLanguage(lang);
        // }
    };

    // Abandonné pour le moment !!!
    const confirmChange = () => {
        if (pendingLang) {

            const supportedLangs = ['fr', 'en', 'de', 'es', 'it'];
            const regex1 = new RegExp(`^questions_villages_(${supportedLangs.join('|')})_(\\d+)$`);
            const regex2 = new RegExp(`^questions_inde_(${supportedLangs.join('|')})_(\\d+)$`);

            let matchLang1 = null;
            let matchId1 = null;

            for (const key of Object.keys(localStorage)) {
                const match = key.match(regex1);
                if (match) {
                    matchLang1 = match[1]; // ex: 'fr'
                    console.log("langue trouvée", matchLang1);
                    matchId1 = match[2];   // ex: '12'
                    console.log("id trouvé", matchId1);
                    break; // si tu veux le premier trouvé
                }
            }
            
            let matchLang2 = null;
            let matchId2 = null;

            for (const key of Object.keys(localStorage)) {
                const match = key.match(regex2);
                if (match) {
                    matchLang2 = match[1]; // ex: 'fr'
                    matchId2 = match[2];   // ex: '12'
                    break; // si tu veux le premier trouvé
                }
            }

            if((matchLang1 && matchId1) || (matchLang2 && matchId2)) {

                localStorage.removeItem(`questions_villages_${matchLang1}_${matchId1}`); // Supprime du stockage local
                localStorage.removeItem(`repLibres_villages_${matchLang1}_${matchId1}`);
                localStorage.removeItem(`repQcm_villages_${matchLang1}_${matchId1}`);
                // localStorage.removeItem(`gameLang-${gameOrParcoursId}`);

                changeLanguage(pendingLang);
                setPendingLang(null);
                setShowModal(false);

                // ✅ Redirige vers la page d’accueil
                navigate("/");
            }
            
        }
    };

    return (
        <>
            <select 
                className={styles.languageDropdown}
                onChange={(e) => handleLanguageChange(e.target.value)}
                value={language}
            >
                <option value="fr">🇫🇷 Français</option>
                <option value="en">🇬🇧 English</option>
                <option value="de">🇩🇪 Deutsch</option>
                <option value="es">🇪🇸 Español</option>
                <option value="it">🇮🇹 Italiano</option>
            </select>

            {showModal && (
                <div className={styles.modalBackdrop}>
                    <div className={styles.modal}>
                        {/* <p>Au moins une partie est en cours. Changer de langue interrompra et effacera la partie en cours. Voulez-vous continuer ?</p> */}
                        <p>Au moins une partie est en cours. Veuillez terminer ou annuler la partie en cours avant de changer de langue.</p>
                        <div className={styles.buttons}>
                            {/* <button onClick={confirmChange}>Oui</button> */}
                            <button onClick={() => setShowModal(false)}>J'ai compris !</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default LanguageSelector;
